import React,{useEffect,useState} from 'react';
import { useParams } from "react-router";
import logo from './logo.svg';
import '../App.css';
import '../scss/home.scss';
import Header from '../component/Header'; 
import {useTranslation} from 'react-i18next'
import parse from 'html-react-parser'
import {Helmet} from "react-helmet";
function Share() {
  let{t} = useTranslation()
  const { style } = useParams();
  const { code } = useParams();
  const { color } = useParams();
  const imageUrl:string="https://freelancedee.com/images/Untitled-1.png";
  return (
    <>
    <Helmet>
        <title>اختر ثلاجة هيتاشي الخاصة بك</title>
        <meta property="og:image" content={imageUrl}/>
        <meta property="og:title" content="اختر ثلاجة هيتاشي الخاصة بك"/>
        <meta property="og:description" content="นี่แหละ! ตู้เย็นฮิตาชิของฉัน"/>
    </Helmet>
    <div className="App container-fuild home">
      <Header/>
      <div className='home-table'><img src={imageUrl} width="1" height="1" className='opacity-0'/></div>
      <div className='container-fuild p-2 VMiddle'>
        <div className="row m-0">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6"></div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 text-start">
                <div className="container-content home-container-content ">
                    <div className="container-block">
                    <h1>{t("home_title")}</h1>
                    <p className=' mt-4'>
                    {parse(t("home_desc"))}
                    </p>
                    </div>
                </div>
                <div className='startbutton'>
                <a className='btn btn-next btn-start' href={`/capacity`}>{t("start")}</a>
                </div>
            </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Share;
